import { render, staticRenderFns } from "./tiendasGeneral.vue?vue&type=template&id=5432bbde&scoped=true&"
import script from "./tiendasGeneral.vue?vue&type=script&lang=js&"
export * from "./tiendasGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432bbde",
  null
  
)

export default component.exports